"use strict";
import {config, errorOptions} from '../_config'
export const languageService = {
  changeLang
}

async function changeLang(lang) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow',
    referrer: 'no-referrer',
    credentials:'include',
    cache: 'no-cache',
    mode: 'cors'
  }
  const rawResponse = await fetch(`${config.apiUrl}/reservas/changeLanguage/${lang}`, requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    });

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await  content
  return  data.result
}



// WEBPACK FOOTER //
// ./src/_services/language.service.js